module.exports = "<h2>Close and archive fiscal year</h2> <p>archive fiscal year</p> <p>Submit + Archive</p> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/crud/clerk-ledger/steps/archive-fiscal-year.html
// module id = 2499
// module chunks = 86